export const appEnvNotProd = () => {
    return process.env.VUE_APP_ENVIRONMENT.toLowerCase() !== 'production'
}